import fromTypes from "../actions/types";
import * as fromOrganisations from "features/organisations";
import { ofType } from "redux-observable";
import { mergeMap, catchError, filter } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { authHeaders, tokenExists, getOrganisationBaseUrl } from "frame";
import {
	onHazardousSubstanceListReceive,
	onHazardousSubstanceListFailed,
} from "../actions";

export const hazardousSubstancesListEffect = (action$, state$) =>
	action$.pipe(
		ofType(
			fromTypes.HAZARDOUS_SUBSTANCES_LIST_REQUESTED,
			fromOrganisations.ORGANISATION_FETCH_SUCCESS,
			fromOrganisations.ORGANISATIONS_CURRENT_ORGANISATION_CHANGED
		),
	filter(() => tokenExists()),
	filter(() => !!state$.value.organisations.currentOrganisation),
	filter(() => state$.value.queue.hasNetwork),
	mergeMap(() =>
		ajax
			.post(
				`${getOrganisationBaseUrl(
					state$.value
				)}/hazardous-substance/paged`,
					{
						page: 1,
						pageSize: 5000,
						orderBy: "createdAt",
						ascending: false,
					},
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(
							onHazardousSubstanceListReceive(
								ajaxResponse.response
							)
						)
					),
					catchError((error) =>
						of(onHazardousSubstanceListFailed(error))
					)
				)
		)
	);

export const hazardousSubstancesPagedListEffect = (action$, state$) =>
	action$.pipe(
		ofType(fromTypes.HAZARDOUS_SUBSTANCES_PAGED_LIST_REQUESTED),
	filter(() => state$.value.organisations.currentOrganisation),
	filter(() => tokenExists()),
	filter(() => state$.value.queue.hasNetwork),
	mergeMap(({ payload }) => {
		const pagingParams = payload;
		return ajax
			.post(
				`${getOrganisationBaseUrl(
					state$.value
				)}/hazardous-substance/paged`,
					pagingParams,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(
							onHazardousSubstanceListReceive(
								ajaxResponse.response
							)
						)
					),
					catchError((error) =>
						of(onHazardousSubstanceListFailed(error))
					)
				);
		})
	);

